import React from 'react';
import NumberFormat from 'react-number-format';
import { AppColors } from 'helpers';
import { useTranslationText } from 'locale';
import { Div, HorizontalView, VerticalView } from 'vendor-deprecated/Wrapper';
import { friendlyURL } from 'helpers/commonUtils';
import { Image } from 'components/common/vendors/Image';
import { TextDisplay } from 'vendor-deprecated/Text';
import { ALink } from 'vendor-deprecated/ALink';
import { ICourse } from 'types/types';
import { SVGIcon } from 'vendor-deprecated/Icon';
import { useAppSetting } from 'helpers/useAppSetting';
import { Hr } from 'vendor-deprecated/CommonParts';

const i18key = 'public.courseDetails';

type AuthorAboutProps = {
  course: ICourse;
};

export const AuthorAbout = React.memo((props: AuthorAboutProps) => {
  const { translation } = useTranslationText();
  const { appSize } = useAppSetting();
  return (
    <VerticalView
      fullWidth
      position={'relative'}
      alignContent={'centerLeft'}
      overflow={'hidden'}
      borderRadius={'4px'}
      border={`1px solid ${AppColors.BORDER}`}
      background={AppColors.BACKGROUND_REVIEW}
      padding={'15px'}
    >
      <VerticalView fullWidth alignContent={'centerLeft'}>
        <TextDisplay size={'20px'} fontWeight={'bold'} marginBottom={'10px'}>
          {translation(`${i18key}.author`)}
        </TextDisplay>
        <Hr />

        <HorizontalView fullWidth alignContent={'centerLeft'} paddingTop={'20px'} paddingBottom={'20px'}>
          <HorizontalView width={'120px'} height={'120px'} borderRadius={'50%'} overflow={'hidden'}>
            <Image
              width={'100%'}
              height={'100%'}
              src={props.course.owner?.profilePath || '/images/avatar.png'}
              objectFit={'cover'}
            />
          </HorizontalView>
          <VerticalView
            alignContent={'centerLeft'}
            width={'calc(100% - 120px)'}
            maxWidth={'300px'}
            paddingLeft={'20px'}
          >
            <ALink
              color={AppColors.PRIMARY}
              size={'20px'}
              fontWeight={700}
              lineHeight={'20px'}
              href={`/teacher/${friendlyURL(props.course.createdBy, props.course.owner?.name || '')}`}
            >
              {props.course.owner?.name || ''}
            </ALink>
            <HorizontalView marginTop={'7px'}>
              <Div marginRight={'10px'}>
                <SVGIcon name={'star'} color={AppColors.ORANGE} />
              </Div>
              <TextDisplay size={appSize.h5}>
                <NumberFormat
                  thousandSeparator={','}
                  displayType={'text'}
                  value={props.course.owner?.avgRate}
                  renderText={(value) => <b>{parseFloat(value).toFixed(1)}</b>}
                />
                {` `}
                {translation(`${i18key}.avgRate`).toLowerCase()}
              </TextDisplay>
            </HorizontalView>
            <HorizontalView marginTop={'7px'}>
              <Div marginRight={'10px'}>
                <SVGIcon name={'statistic'} color={AppColors.ORANGE} />
              </Div>
              <TextDisplay size={appSize.h5}>
                <b>
                  <NumberFormat thousandSeparator={','} value={props.course.owner?.totalReviews} displayType={'text'} />
                </b>
                {` `}
                {translation(`${i18key}.totalReview`).toLowerCase()}
              </TextDisplay>
            </HorizontalView>
            <HorizontalView marginTop={'7px'}>
              <Div marginRight={'10px'}>
                <SVGIcon name={'case'} color={AppColors.ORANGE} />
              </Div>
              <TextDisplay size={appSize.h5}>
                <b>{props.course.owner?.totalCourses || 0}</b> {translation(`${i18key}.course`).toLowerCase()}
              </TextDisplay>
            </HorizontalView>
            {/* <HorizontalView marginTop={'7px'}>
              <Div marginRight={'10px'}>
                <SVGIcon name={'user'} color={AppColors.ORANGE} />
              </Div>
              <TextDisplay size={appSize.h5}>
                {props.course.owner?.totalStudents || 0} {translation(`${i18key}.student`)}
              </TextDisplay>
            </HorizontalView> */}
          </VerticalView>
        </HorizontalView>
        <div dangerouslySetInnerHTML={{ __html: props.course.owner?.description || '' }} />
      </VerticalView>
    </VerticalView>
  );
});
